import type {SVGProps, VoidFunctionComponent} from 'react';

export const ChevronDownIcon: VoidFunctionComponent<SVGProps<SVGSVGElement>> = (props) => (
    <svg {...props} viewBox='0 0 16 16' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
        <path d='M4.94 5.7207L8 8.7807L11.06 5.7207L12 6.66737L8 10.6674L4 6.66737L4.94 5.7207Z'/>
    </svg>
);
